export default __webpack_public_path__ + "static/media/user-flows.338c4b7c.png";